"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  app_name: "Fysiotest Europa AB",
  common: {
    placeholders: {
      email: "E-post",
      password: "Lösenord",
      personal_number: "ÅÅÅÅMMDDXXXX",
      personal_number_full: "Personnummer",
      gender: "Kön",
      company: "Företag",
      office: "Kontor",
      department: "Avdelning",
      individual_client: "Enskild kund",
      mark_all: "Markera alla",
      no_data: "Inga data"
    },
    messages: {
      unknown_error: "Något gick fel.. försök igen",
      email: "info@fysiotest.se",
      fysiotest_email: "E-post:",
      large_image_error: "Bilden är för stor.",
      large_image_size_error: "Bilden är för stor. Rekommenderad storlek är {size}Mb",
      large_file_size_error: "Fil är för stor. Rekommenderad storlek är {size}Mb",
      isIE: "Webbsidan du önskar nå kräver någon av nedanstående webbläsare för att fungera optimalt.",
      image_updated: "Bilden har uppdaterats"
    },
    words: {
      second: "{count} sekund | {count} sekunder",
      and: "och",
      or: "eller",
      no_records: "Inga resultat",
      add: "Lägg till",
      edit: "Redigera",
      yes: "Ja",
      no: "Nej"
    },
    buttons: {
      log_out: "Logga ut",
      previous_page: "Tillbaka",
      ok: "Ok",
      cancel: "Avbryt",
      change_test_result_date: "Ändra testdatum",
      change_appointment_date: "Redigera utnämningen"
    },
    menus: {
      my_profile: "Min profil",
      companies: "Företag",
      projects: "Projekt",
      admins: "Admins",
      test_managers: "Testledare",
      tests: "Tester",
      composed_tests: "Komponerade tester",
      customers: "Kunder"
    },
    calendar: {
      monday_short: "Må",
      tuesday_short: "Ti",
      wednesday_short: "Ons",
      thursday_short: "To",
      friday_short: "Fr",
      saturday_short: "Lö",
      sunday_short: "Sö",
      january_long: "Januari",
      february_long: "Februari",
      march_long: "Mars",
      april_long: "April",
      may_long: "Maj",
      june_long: "Juni",
      july_long: "Juli",
      august_long: "Augusti",
      september_long: "September",
      october_long: "Oktober",
      november_long: "November",
      december_long: "December"
    }
  },
  login: {
    headers: {
      login: "Logga in",
      two_factor_authentication: "Tvåfaktorsautentisering",
      verification_code_info: "En verifieringskod har skickats till\nditt e-post.\nAnge koden f\xF6r att forts\xE4tta.",
      contact_us: "Kontakta oss"
    },
    buttons: {
      login_bank_id: "Med BankID",
      login_email: "Med e-post",
      start_login: "Logga in",
      forgot_password: "Glömt ditt lösenord?",
      next_step: "Nästa",
      try_again: "Försök igen",
      start_bank_id_app: "Starta din BankID-app",
      start_bank_id_same_device: "Starta bank id på denna enhet",
      start_bank_id_another_device: "Bank ID på annan enhet"
    },
    placeholders: {
      two_factor_placeholder: "Välj alternativ för tvåstegsverifiering",
      two_factor_email: "Skicka verifieringskoden som e-post",
      two_factor_sms: "Skicka verifieringskoden som SMS"
    },
    messages: {
      short_personal_number: "Ange ditt personnummer med 12 siffror",
      open_bank_id: "Starta BankID-appen och tryck på knappen Skanna QR. Skanna sedan QR-koden ovan",
      bank_id_failed: "Inloggning via BankID misslyckades. Försök igen",
      failed_to_scan: "Det gick inte att skanna QR-koden. Starta BankID-appen och skanna QR-koden"
    }
  },
  sign_up: {
    headers: {
      register: "Registera dig",
      register_bank_id: "Registrera dig hos {app_name}",
      register_email: "Registrera dig hos {app_name}",
      two_factor_authentication: "Tvåfaktorsautentisering",
      verification_code_is_sent: "En verifieringskod har skickats till\nditt e-post.\nAnge koden f\xF6r att forts\xE4tta."
    },
    buttons: {
      register_bank_id: "Med BankID",
      register_email: "Med e-post",
      register: "Registrera",
      login: "Logga in"
    },
    placeholders: {
      firstname: "Förnamn",
      lastname: "Efternamn",
      phone: "Telefon",
      password: "Skapa lösenord",
      confirm_password: "Bekräfta lösenord",
      date_of_birth: "Födelsedatum"
    },
    messages: {
      open_bank_id_app: "Öppna BankID-appen och godkänn",
      personal_number_is_registered: "Personnumret är redan registrerat. Logga in istället",
      email_is_registered: "E-Post är redan registrerat. Logga in istället",
      weak_password: "Svagt lösenord!"
    },
    validation: {
      firstname: {
        empty: "Förnamn är obligatoriskt"
      },
      lastname: {
        empty: "Efternamn är obligatoriskt"
      },
      date_of_birth: {
        empty: "Födelsedatum är obligatoriskt",
        invalid_date: "Födelsedatum baserat på ditt personnummer är felaktig"
      },
      email: {
        empty: "E-post är obligatoriskt",
        incorrect_format: "E-post adressen måste vara i rätt format - namn@domän"
      },
      personal_number: {
        incorrect_length: "Ange ditt personnummer med 12 siffror"
      },
      company: {
        empty: "Företaget är obligatoriskt"
      },
      office: {
        empty: "Kontor är obligatorisk"
      },
      department: {
        empty: "Avdelning är obligatorisk"
      },
      phone: {
        empty: "Mobilnummer är obligatorisk",
        invalid: "Mobilnummer är ogiltig"
      },
      gender: {
        empty: "Kön är obligatorisk"
      },
      password: {
        not_match: "Lösenorden matchar inte",
        short: "Lösenordet måste vara minst 8 tecken",
        no_uppercase: "Lösenordet måste innehålla en stor bokstav",
        no_lowercase: "Lösenordet måste innehålla en liten bokstav",
        no_digit: "Lösenordet måste innehålla en siffra",
        no_non_alphabetical: "Lösenordet måste innehålla ett icke-alfabetiskt tecken"
      }
    }
  },
  reset_password: {
    headers: {
      enter_email: "Vänligen ange din e-postadress",
      reset_password: "Återställ ditt lösenord med bekräftelsekoden du har fått till din e-post"
    },
    buttons: {
      send_new_secret_code: "Fick du inte ett mail? Klicka här för att skicka en ny bekräftelsekod",
      send_secret_code: "Skicka",
      set_new_password: "Ange nytt lösenord"
    },
    placeholders: {
      secret_code: "Bekräftelsekod",
      create_password: "Skapa lösenord",
      confirm_password: "Bekräfta lösenord"
    },
    messages: {
      resend_secret_code_counter: "Fick du inte ett mail? Du kan skicka en ny bekräftelsekodi i",
      password_is_set: "Nytt lösenord är sparad!",
      weak_password: "Svagt lösenord!"
    },
    validation: {
      secret_code: {
        empty: "Bekräftelsekoden krävs"
      },
      password: {
        not_match: "Lösenorden matchar inte",
        short: "Lösenordet måste vara minst 8 tecken",
        no_uppercase: "Lösenordet måste innehålla en stor bokstav",
        no_lowercase: "Lösenordet måste innehålla en liten bokstav",
        no_digit: "Lösenordet måste innehålla en siffra",
        no_non_alphabetical: "Lösenordet måste innehålla ett icke-alfabetiskt tecken"
      }
    }
  },
  terms: {
    headers: {
      page_header: "{app_name} - ANVÄNDARVILLKOR",
      terms_accept: "Användarvillkor app.fysiotest.se.",
      show_terms: "Villkor och policy",
      terms_details_1: "1. Vem är ansvarig för dina personuppgifter?",
      terms_details_2: "2. Vilka personuppgifter behandlar Fysiotest?",
      terms_details_3: "3. För vilka ändamål behandlar vi dina personuppgifter?",
      terms_details_4: "4. Hur länge sparar vi dina personuppgifter?",
      terms_details_5: "5. Hur får du tillgång till dina uppgifter i ‘Min portal’?",
      terms_details_6: "6. Hur skyddar vi dina personuppgifter?",
      terms_details_7: "7. Hur används ‘Cookies’?",
      terms_details_8: "Kontaktuppgifter"
    },
    messages: {
      welcome: "Välkommen {name}!",
      welcome_description: "Här i vår portal kan du boka tid för hälsoundersökning, fylla i hälsodeklaration samt se resultat på dina tester. Läs igenom och godkänn användarvillkoren för att komma vidare.",
      accept_checkbox: " Jag accepterar Fysiotests användarvillkor",
      terms_details_0: "\n        <p>Vi v\xE4rnar om din personliga integritet och vill d\xE4rf\xF6r med dessa anv\xE4ndarvillkor och Integritetspolicy vara tydliga med vilken information vi samlar in om dig och varf\xF6r n\xE4r du anv\xE4nder v\xE5ra tj\xE4nster eller bes\xF6ker v\xE5r hemsida. F\xF6r att bli registrerad anv\xE4ndare av app.fysiotest.se beh\xF6ver du l\xE4sa och godk\xE4nna denna policy.</p>\n      ",
      terms_details_1: "\n                <p>1.1 Fysiotest Europa AB (\u201CFysiotest\u201D eller \u201DBolaget\u201D), organisationsnummer 556796-0330, Box 2096 141 02 Huddinge, \xE4r personuppgiftsansvarig f\xF6r behandlingen av personuppgifter p\xE5 denna webbplats. Bolagets behandling av kunduppgifter f\xF6ljer dataskyddsf\xF6rordningen (GDPR).</p>\n                <p>1.2 Med \"anv\xE4ndare\" avses enskilda personer och med \"kunder\" avses f\xF6retag som anv\xE4nder Bolagets tj\xE4nster f\xF6r blodanalyser, h\xE4lsokontroller, h\xE4lsocoaching samt \xF6vriga tj\xE4nster som sedan erh\xE5ller journalhandlingar r\xF6rande de aktuella resultaten via app.fysiotest.se.</p>\n                <p>1.3 Behandlingen av personuppgifter vid anv\xE4ndning av Bolagets tj\xE4nster sker efter att anv\xE4ndaren har f\xE5tt information om och l\xE4mnat sitt samtycke till behandlingen. Behandlingen av personuppgifter har \xE4ven st\xF6d i dataskyddsf\xF6rordningen (GDPR).</p>\n                <p>1.4 Bolaget f\xF6ljer \xE4ven \xF6vrig relevant lagstiftning s\xE5som Offentlighets- och sekretesslagen (2009:400) och Patientdatalagen (2008:355) i de delar som r\xF6r kundens personuppgifter. Detta inneb\xE4r att regler fr\xE5n dessa lagar kan f\xF6retr\xE4da GDPR i vissa delar som ber\xF6r kundens personuppgifter.</p>\n            ",
      terms_details_2: "\n                <p>2.1 Bolaget samlar in personuppgifter s\xE5som f\xF6rnamn, efternamn, e-postadress, telefonnummer, k\xF6n och personnummer fr\xE5n kunder i samband med anv\xE4ndningen av Bolagets tj\xE4nster. Bolagets tj\xE4nster innefattar insamling av h\xE4lsodata i samband med blodanalyser, h\xE4lsokontroller samt \xF6vriga tj\xE4nster. Vi samlar endast in de uppgifter som \xE4r n\xF6dv\xE4ndiga f\xF6r att leverera tj\xE4nsten.</p>\n            ",
      terms_details_3: "\n                <p>3.1 Personuppgifterna anv\xE4nds f\xF6r att tillhandah\xE5lla Bolagets tj\xE4nster f\xF6r anv\xE4ndare och kunder. Personuppgifter anv\xE4nds ocks\xE5 f\xF6r att g\xF6ra h\xE4lsodata tillg\xE4nglig f\xF6r anv\xE4ndaren. H\xE4lsodata samlas in i syfte att optimera nutrition, motion och \xE5terh\xE4mtning. H\xE4lsodata insamlad av bolaget anv\xE4nds inte i medicinska syften. Personuppgifter f\xF6r anv\xE4ndare anv\xE4nds vid informationsutskick inf\xF6r aktuella h\xE4lsokontroller samt f\xF6r kunder p\xE5 v\xE5ra fysiska kliniker d\xE4r dessa \xE4ven inkluderar fakturering.</p>\n                <p>3.2 H\xE4lsodata kan komma att i avidentifierad form analyseras och sammanst\xE4llas i generella rapporter f\xF6r anv\xE4ndning av b\xE5de anv\xE4ndare och kunder f\xF6r att sammanfatta resultaten p\xE5 gruppniv\xE5. Datan i rapporten sammanst\xE4lls p\xE5 ett s\xE5dant s\xE4tt att den aldrig kan kopplas till en individ och/eller enskilda personuppgifter f\xF6r att s\xE4kerst\xE4lla att anv\xE4ndarnas anonymitet och integritet uppr\xE4tth\xE5lls.</p>\n                <p>3.3 Bolagets kunder och registrerade anv\xE4ndare samtycker till marknadsf\xF6ring via olika kanaler s\xE5som post, telefon, e-post, sms samt andra digitala kanaler. Marknadsf\xF6ring via e-post och sms regleras enligt marknadsf\xF6ringslagen.</p>\n                <p>3.4  F\xF6r att Fysiotest ska kunna tillhandah\xE5lla v\xE5ra tj\xE4nster beh\xF6ver vi samarbeta med andra akt\xF6rer, t.ex. h\xE4lsocoacher, labb och systemleverant\xF6rer. Vi kan d\xE4rf\xF6r komma att \xF6verf\xF6ra dina personuppgifter och ta hj\xE4lp av andra akt\xF6rer f\xF6r att behandla dina personuppgifter n\xE4r det \xE4r n\xF6dv\xE4ndigt f\xF6r att (1) uppfylla avtalet med dig, (2) efterleva lag, f\xF6rfattning eller beslut. F\xF6ljande typer av mottagare kan bli aktuella:</p>\n                <p>a) Provtagningspartners och labb \u2013 Fysiotest samarbetar med olika provtagningspartners och laboratorier f\xF6r att ta och analysera vissa av de prover som ing\xE5r i best\xE4llda analyser. </p>\n                <p>b) Kontrakterad personal - Fysiotest har samarbeten med utvalda akt\xF6rer som utf\xF6r provtagning och h\xE4lsocoaching.</p>\n                <p>c) Myndigheter -  Personuppgifter l\xE4mnas endast ut till myndigheter n\xE4r det kr\xE4vs enligt lag eller myndighetsbeslut.</p>\n                <p>d) Aviseringstj\xE4nster \u2013 Fysiotest anv\xE4nder tj\xE4nster f\xF6r att kommunicera automatiskt till dig, ex. med bekr\xE4ftelser eller p\xE5minnelser. Dessa f\xF6retag f\xE5r bara tillg\xE5ng till din kontaktuppgift och har \xE5tagit sig att inte dela dina personuppgifter ut\xF6ver vad som \xE4r n\xF6dv\xE4ndigt f\xF6r att genomf\xF6ra tj\xE4nsten.</p>\n                <p>e) Utvecklare och konsulter \u2013 Fysiotest tar hj\xE4lp av utvecklare och konsulter fr\xE5n andra f\xF6retag f\xF6r att bygga v\xE5r IT-infrastruktur och vidareutveckla tj\xE4nsten. S\xE5dana utvecklare kan beh\xF6va f\xE5 tillg\xE5ng till personuppgifter om dig n\xE4r detta beh\xF6vs f\xF6r utveckling eller fels\xF6kning.</p>\n                <p>f) Din arbetsgivare \u2013 Med laglig grund i Fysiotests, din arbetsgivares och ditt egna ber\xE4ttigade intresse att utg\xF6ra faktureringsunderlag och rapportera f\xF6r eventuell f\xF6rm\xE5nsbeskattning delger Fysiotest ditt namn till din arbetsgivare endast om din arbetsgivare har best\xE4llt och/eller betalat f\xF6r det h\xE4lsotest du tagit.</p>\n                <p>3.5 K\xE4nsliga uppgifter om dig, d\xE4ribland dina h\xE4lsouppgifter, behandlas i enlighet med lag. S\xE5dana uppgifter kommer d\xE4rf\xF6r bara att vara tillg\xE4ngliga f\xF6r s\xE5dan personal som ska ha tillg\xE5ng till dem enligt lag. Uppgifterna kommer inte att l\xE4mnas ut eller \xF6verf\xF6ras till n\xE5gon mottagare annat \xE4n n\xE4r s\xE5 f\xE5r ske enligt lag.</p>\n                <p>3.6 Tredjelands\xF6verf\xF6ring<br>Fysiotest behandlar s\xE5 mycket av sin data som m\xF6jligt inom EU/EES. Om data \xF6verf\xF6rs f\xF6r att behandlas av en leverant\xF6r eller underleverant\xF6r utanf\xF6r EU/EES har mottagaren alltid ing\xE5tt avtalsvillkor med Fysiotest som s\xE4kerst\xE4ller att mottagaren uppr\xE4tth\xE5ller en skyddsniv\xE5 j\xE4mf\xF6rbar med EU/EES.</p>\n            ",
      terms_details_4: "\n                <p>4.1 Personuppgifter sparas under den tid d\xE5 det finns en p\xE5g\xE5ende avtalsrelation och en tid d\xE4refter, eller enligt l\xE4mnat samtycke. Kunden kan n\xE4r som helst \xE5terkalla sitt samtycke.</p>\n                <p>4.2 F\xF6r patientjournaler sparar Bolaget som v\xE5rdgivare dessa i enlighet med g\xE4llande lagstiftning, vanligtvis under minst tio (10) \xE5r fr\xE5n det att den sista uppgiften f\xF6rdes in i handlingen.</p>\n                <p>4.3 Bolaget beh\xE5ller anv\xE4ndarnas personuppgifter f\xF6r bokf\xF6rings \xE4ndam\xE5l enligt de krav som f\xF6ljer av bokf\xF6ringslagen, vanligtvis i sju \xE5r.</p>\n                <p>4.4 Uppgifterna i \u201CMin portal\u201D klassas som patientjournal och Bolaget som v\xE5rdgivare sparar dessa i enlighet med g\xE4llande lagstiftning, vanligtvis under minst tio (10) \xE5r fr\xE5n det att den sista uppgiften f\xF6rdes in i handlingen. Anv\xE4ndaren \xE4ger r\xE4tten att p\xE5 beg\xE4ran f\xE5 sina uppgifter raderade. \xD6vriga personuppgifter och data kopplat till anv\xE4ndarkontot s\xE5som f\xF6retagstillh\xF6righet kan komma att gallras eller avpersonifieras n\xE4r uppgifterna inte l\xE4ngre beh\xF6vs f\xF6r de \xE4ndam\xE5l de samlades in f\xF6r. Personuppgifter f\xF6r anv\xE4ndarkonton med p\xE5g\xE5ende aktivitet och/eller saldo undantas fr\xE5n gallring.</p>\n                <p>4.5 Under bevarandetiden begr\xE4nsas anv\xE4ndningen av personuppgifter med h\xE4nsyn till de specifika \xE4ndam\xE5l f\xF6r vilka de samlades in. Gallringen \xE4r o\xE5terkallelig och n\xE4r den har genomf\xF6rts kan inte n\xE5gon person l\xE4ngre associeras med anv\xE4ndarkontot.</p>\n            ",
      terms_details_5: "\n        <p>5.1 Anv\xE4ndare av Fysiotests tj\xE4nster har m\xF6jlighet att sj\xE4lva l\xE4sa och ta del av sina uppgifter via app.fysiotest.se. Under \u201DMin portal\u201D d\xE4r han eller hon kan f\xF6lja sina testresultat och f\xF6lja sina v\xE4rden \xF6ver tid. H\xE4r kan anv\xE4ndaren hitta information om hur resultatet skall tolkas ur ett h\xE4lsofr\xE4mjande perspektiv.</p>\n        <p>5.2 Registerutdrag. Alla Fysiotests anv\xE4ndare har r\xE4tt att skriftligen utan kostnad \xE5terkalla samtycke, beg\xE4ra ett registerutdrag eller r\xE4ttelse/radering av eventuellt felaktiga uppgifter. Om du vill beg\xE4ra ett registerutdrag, \xE5terkalla ett samtycke eller r\xE4tta/radera en uppgift ber vi dig att kontakta oss.</p>\n      ",
      terms_details_6: "\n        <p>6.1 Bolaget vidtar som personuppgiftsansvarig l\xE4mpliga tekniska och organisatoriska \xE5tg\xE4rder f\xF6r att s\xE4kerst\xE4lla skyddet av de personuppgifter som behandlas, i enlighet med kraven i GDPR och andra till\xE4mpliga lagar och f\xF6rordningar.</p>\n      ",
      terms_details_7: "\n                <p>7.1 P\xE5 Bolagets hemsida anv\xE4nds cookies. Cookies \xE4r sm\xE5 textfiler som lagras p\xE5 bes\xF6karens enhet och som m\xF6jligg\xF6r att webbplatsen kan k\xE4nna igen bes\xF6karen och samla in information om deras aktiviteter p\xE5 webbplatsen.</p>\n                <p>7.2 Det finns tv\xE5 huvudtyper av cookies:\n                  <ul class=\"ml-min\">\n                    <li>Permanent cookie: Denna typ av cookie ligger kvar p\xE5 bes\xF6karens enhet under en best\xE4md tid, \xE4ven efter att webbl\xE4saren har st\xE4ngts.</li>\n                    <li>Sessionscookie: Denna typ av cookie lagras tillf\xE4lligt i enhetens minne under den tid bes\xF6karen \xE4r inne p\xE5 webbplatsen och f\xF6rsvinner n\xE4r webbl\xE4saren st\xE4ngs.</li>\n                  </ul>\n                </p>\n                <p>\n                    7.3 Bolaget anv\xE4nder cookies av f\xF6ljande sk\xE4l:\n                    <ul class=\"ml-min\">\n                        <li>\n                            F\xF6r att s\xE4kerst\xE4lla att tj\xE4nsterna p\xE5 webbplatsen fungerar korrekt.\n                        </li>\n                        <li>\n                            F\xF6r att samla in anonymiserad bes\xF6ksstatistik och analysera anv\xE4ndarbeteenden f\xF6r att f\xF6rb\xE4ttra webbplatsens prestanda och anv\xE4ndarupplevelse.\n                        </li>\n                        <li>\n                            F\xF6r att anpassa och visa annonser baserat p\xE5 bes\xF6karens intressen och beteenden.\n                        </li>\n                    </ul>\n                </p>\n                <p>\n                    7.4 Ingen personlig information, s\xE5som e-postadress eller namn, sparas i cookies om bes\xF6karen.\n                </p>\n                <p>7.5 Om bes\xF6karen inte vill att cookies ska anv\xE4ndas kan de st\xE4nga av cookies i sina webbl\xE4sares s\xE4kerhetsinst\xE4llningar. Observera att vissa funktioner p\xE5 webbplatsen kanske inte fungerar korrekt om cookies \xE4r inaktiverade.</p>\n                <p>7.6 Bes\xF6karen kan ocks\xE5 konfigurera sin webbl\xE4sare s\xE5 att de f\xE5r en varning varje g\xE5ng webbplatsen f\xF6rs\xF6ker placera en cookie p\xE5 deras enhet. Dessutom kan tidigare lagrade cookies raderas genom webbl\xE4sarens inst\xE4llningar. F\xF6r mer information om detta, se webbl\xE4sarens hj\xE4lpsidor.</p>\n                <p>7.7 F\xF6r ytterligare information om cookies kan bes\xF6karen kontakta Post- och telestyrelsen, som \xE4r den tillsynsmyndighet som ansvarar f\xF6r omr\xE5det. Bes\xF6k PTS webbplats p\xE5 http://www.pts.se/</p>\n                <p>Om du vill ut\xF6va dina r\xE4ttigheter enligt GDPR kan du skicka brev till Fysiotest p\xE5 adressen:</p>\n                <p>Fysiotest Europa AB<br>Box 2096<br>141 02 Huddinge<br>Sverige</p>\n                <p>Eller skicka e-post till Fysiotest p\xE5 <a href=\"mailto:info@fysiotest.se\">info@fysiotest.se</a></p>\n                <p><i>Dessa anv\xE4ndarvillkor uppr\xE4ttades i augusti 2017 och \xE4r senast uppdaterad i januari 2026 av Fysiotest Europa AB</i></p>\n              ",
      terms_details_8: "\n        <p>Om du vill ut\xF6va dina r\xE4ttigheter enligt GDPR kan du skicka brev till Fysiotest p\xE5 adressen:</p>\n        <p>Fysiotest Europa AB<br>Box 2096<br>141 02 Huddinge<br>Sverige</p>\n        <p>Eller skicka e-post till Fysiotest p\xE5 <a href=\"mailto:info@fysiotest.se\">info@fysiotest.se</a></p>\n        <p><i>Dessa anv\xE4ndarvillkor uppr\xE4ttades i augusti 2017 och \xE4r senast uppdaterad i januari 2026 av Fysiotest Europa AB</i></p>\n      "
    },
    buttons: {
      accept_terms: "Jag accepterar"
    }
  },
  dashboard: {
    headers: {
      my_portal: "Min hälsa & prestation",
      welcome: "Välkommen {name}",
      health_goals: "Mina mål",
      new_health_goal: "Nytt hälsomål",
      no_tests: "Här kommer du kunna följa din utveckling när du har gjort flera tester.",
      outdated_occasion: "Testtillfället har passerat",
      deleted_occasion: "Testetiden togs bort",
      book_time: "Boka tid",
      no_booking_time: "Inga tider lediga",
      edit_health_goal: "Redigera mål",
      you_have_booked: "Du har bokat tid: {date}",
      you_have_booked_time: "Du har bokat tid",
      booked_time: "{date} för {type}",
      you_have_booked_location: "Plats",
      cancel_appointment: "Avboka tiden?",
      click_here: "Klicka här",
      messages: "Meddelanden"
    },
    messages: {
      welcome_information: "Här i vår portal kan du boka tid för hälsoundersökning, fylla i hälsodeklaration samt se rapporter på dina tidigare tester",
      no_health_goals: "Inga mål",
      occasion_date: "Datum",
      occasion_files: "Information",
      occasion_project: "Projekt",
      occasion_deleted_project: "Projekt raderat",
      occasion_contact: "Kontaktperson",
      select_type: "Välj tjänst",
      select_location: "Välj plats",
      select_date_and_time: "Välj datum och tid",
      test_is_completed: "Test slutfört",
      test_is_deleted: "Test raderas",
      healthdeclaration_is_submitted: "{name} inskickad",
      waiting_for_test: "Väntar på {name}",
      time_is_booked: "Tid bokad",
      waiting_for_booking: "Väntar på att tid ska bokas",
      status: "Status",
      test: "Testa",
      sms_sent: "SMS skickad"
    },
    buttons: {
      add_health_goal: "Lägg till hälsomål",
      create_health_goal: "Lägg till mål",
      cancel_booking: "Avboka tid ({date})",
      open_book_time_menu: "Boka tid",
      open_healthdeclaration: "Fyll i {name}",
      open_covid_certificate: "E-Hälsomyndighet - {name}",
      book_time: "Boka",
      save_health_goal: "Spara",
      upload_goal_picture: "Ladda upp din egen målbild här",
      change_goal_picture: "Ändra bilden?",
      save: "Spara",
      cancel: "Avbryt",
      cancel_on_icon: "Avboka",
      test_results: "Mina testresultat",
      test_development: "Min utveckling"
    },
    placeholders: {
      your_goal: "Ditt mål",
      select_booking_date: "Välj datum",
      select_booking_type: "Välj tjänst",
      select_booking_location: "Välj plats",
      select_booking_time: "Välj tid",
      goal: "Målet"
    },
    deleteBookingConfirmation: "Är du säker att du vill avboka din tid?"
  },
  footer: {
    headers: {
      newsletter: "Få inspiration via vårt nyhetsbrev"
    },
    placeholders: {
      email: "E-postadress"
    },
    buttons: {
      subscribe: "Prenumerera"
    }
  },
  user_profile: {
    titles: {
      delete_info: "Begär avregistrering av konto",
      datepicker: "Redigering av födelsedatum är begränsad eftersom det redan är hämtat från personnumret"
    },
    buttons: {
      save_profile_picture: "Spara",
      cancel: "Avbryt",
      change_profile: "Ändra profil",
      update_profile_information: "Uppdatera uppgifter",
      delete_request: "Radera mitt konto",
      delete: "Radera"
    },
    placeholders: {
      change_picture: "Byt bild",
      gender_male: "Man",
      gender_female: "Kvinna"
    },
    messages: {
      health_goals_count: "Hälsomål",
      tests_count: "Tester"
    },
    validation: {
      email_personal_number: {
        empty: "Antingen e-post eller personnummer eller båda behöver anges"
      }
    }
  },
  tests: {
    headers: {
      question_description: "Beskrivning"
    },
    buttons: {
      download_pdf: "Ladda ner som PDF",
      submit: "Skicka in",
      create_covid_passport: "Skapa Covidbevis"
    },
    messages: {
      user_answer: "Ditt svar",
      value: "Värde",
      reference_value: "Referensvärde",
      show_less: "- Visa mindre",
      show_more: "+ Läs mer här",
      inbody_vfa_result: "Din bukfett \xE4r (kvcm) <span class=\"underline\">%{answer}</span>.",
      inbody_result: "Ditt resultat: {result}",
      inbody_over: "Över",
      inbody_under: "Under",
      inbody_normal: "Normal",
      inbody_result_over: "Ditt resultat {result} är över",
      inbody_result_under: "Ditt resultat {result} in under",
      inbody_result_normal: "Ditt resultat {result} is normal",
      inbody_normal_ranges: "Ditt normalintervall: {minRange} – {maxRange}",
      inbody_normal_ranges_percentages: "Normalintervall i procent: {minRange} – {maxRange}",
      inbody_weight: "Vikt (kg)",
      inbody_smm: "Skelettmuskelmassa (kg)",
      inbody_bfm: "Fettmassa (kg)",
      inbody_pbf: "Fettprocent (%)",
      inbody_vfa: "Visceral Fett Area (%)",
      yes_answer: "Ja",
      no_answer: "Nej",
      starting_autosave: "Börjar automatiskt spara resultat ...",
      successful_autosave: "Dina svar har sparats automatiskt",
      unsuccessful_autosave: "Fel vid autospar",
      autosave_applied: "Dina autosparade resultat är applicerade"
    }
  },
  round: {
    enter_valid_name: "Ange ett giltigt namn"
  },
  occasion: {
    cards: {
      files: {
        action: "Ladda upp"
      }
    },
    forms: {
      upload_file: {
        title: "Ny fil"
      },
      inbody: {
        title: "Nytt InBody test",
        file_name_mismatch: 'Filnamnet "{file}" inkluderar inte det fullständiga namnet för {fullName}'
      }
    }
  },
  test_types: {
    headers: {
      name: "Namn",
      global: "Globalt",
      created: "Skapades",
      updated: "Senast ändrad",
      test_type: "Typ av testmall",
      test_category: "Testkategori"
    },
    columns: {
      yes: "ja",
      no: "nej"
    }
  },
  contact: {
    message_not_sent: "Meddelandet skickas inte"
  },
  occasion_times: {
    time: "Tid",
    booked: "Bokad",
    name: "Namn",
    type: "Typ",
    location: "Plats",
    bulk_delete: "För att radera flera tider samtidigt, klicka på de rader du önskar ta bort",
    add_time: "Lägg till en tid",
    add_bulk_times: "Lägg till flera tider",
    open_booking: "öppna bokningar",
    lock_bookings: "Lås bokningar",
    remove_selected: "Ta bort valda",
    select_type: "Välj tjänst",
    select_location: "Välj plats"
  },
  report: {
    created: "Rapportfil skapad"
  },
  confirmation_modal: {
    title: "Är du säker?",
    text: "Du kommer inte kunna återgå till det här!"
  },
  occasion_files: {
    removed: "Filen tas bort"
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/translations/sv.js
// module id = pZ/B
// module chunks = 0 1